import React from 'react';
import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import {
  useMinisiteProducts, isMinisite, MinisiteOccasionGrid, MinisiteProductCard, GalerieInvitesTeaser,
} from './MinisiteCatalogPage';
import { MINISITE_HUB_PATH } from '../utils/minisiteOccasions';

// Bloc de l'accueil qui présente la gamme « faire-part et invitations animés » à côté des cartes à
// gratter : une tuile par occasion, quelques modèles, et la galerie photos des invités.
// Modèles mis en avant : les compositions des visuels les plus vendus de la boutique.
const EN_AVANT = ['faire-part-mariage-anime-fleurs-bleues-aquarelle', 'faire-part-mariage-anime-tulipes-blanches-eucalyptus', 'faire-part-mariage-anime-noir-or-glamour'];

const HomeAnimatedInvitations = () => {
  const products = useMinisiteProducts();
  if (products !== null && !products.some(isMinisite)) return null; // gamme pas encore en base

  const enAvant = EN_AVANT.map((url) => (products || []).find((p) => p.url === url)).filter(Boolean);

  return (
    <Box sx={{ marginTop: 8, marginBottom: 8 }}>
      <Typography variant="h2" component="h2" sx={{ textAlign: 'center', marginBottom: 1.5 }}>
        Nouveau : faire-part et invitations animés
      </Typography>
      <Typography sx={{ maxWidth: 720, margin: '0 auto 32px', textAlign: 'center', color: '#7a6060' }}>
        Une invitation qui s'ouvre comme une petite page animée sur le téléphone de vos proches : le prénom apparaît en
        douceur, puis la date, votre photo et, selon la formule, le lieu avec son plan — et les réponses de vos invités en ligne.
        Sans Canva, sans compte, sans abonnement.
      </Typography>

      <MinisiteOccasionGrid products={products} />

      {enAvant.length > 0 && (
        <>
          <Typography variant="h4" component="h3" sx={{ textAlign: 'center', marginTop: 6, marginBottom: 3 }}>
            Nos modèles préférés
          </Typography>
          <Grid container spacing={3}>
            {enAvant.map((product) => (
              <Grid item xs={12} sm={6} md={4} key={product.id}><MinisiteProductCard product={product} /></Grid>
            ))}
          </Grid>
        </>
      )}

      <Box sx={{ textAlign: 'center', marginTop: 4 }}>
        <Button variant="contained" color="secondary" component={Link} to={MINISITE_HUB_PATH} sx={{ borderRadius: 6, px: 4, py: 1.2, fontWeight: 700 }}>
          Voir tous les faire-part et invitations animés
        </Button>
      </Box>

      <GalerieInvitesTeaser products={products} />
    </Box>
  );
};

export default HomeAnimatedInvitations;
